export default "__VITE_ASSET__CIL51ed1__"